import { Container, Row, Col, Button } from "react-bootstrap";
import "./CivilBlock.css";
import { useHrStyles } from "../../Context/HRContext";

export default function CivilBlock() {
  const hrStyles = useHrStyles();
  return (
    <Container className="Struct-Container">
      <Row className="justify-content-center align-items-center mb-5">
        <Col md={6} className="Struct-Text">
          <h1 className="Struct-Head">Planning</h1>
          <p className="Struct-Para">
            Effective planning is the cornerstone of every successful civil
            engineering project. Our planning services focus on thorough
            analysis, detailed site assessments, and the development of
            efficient strategies to ensure the smooth execution of projects from
            start to finish.
          </p>
          <Button
            href="/Contact"
            className="Struct-Button"
            variant="outline-success"
          >
            Contact Us
          </Button>
        </Col>
        <Col md={6}>
          <img
            src="/assets/images/c1.jpg"
            alt="Structural"
            style={{
              borderRadius: "25px",
              boxShadow: "8px 8px 5px rgba(0, 0, 0, 0.1)",
            }}
          />
        </Col>
      </Row>

      <Row className="justify-content-center align-items-center mb-3">
        <Col md={6}>
          <img
            src="/assets/images/c2.jpg"
            alt="Structural"
            style={{
              borderRadius: "25px",
              boxShadow: "8px 8px 5px rgba(0, 0, 0, 0.1)",
              marginBottom: "1em",
            }}
          />
        </Col>
        <Col md={6} className="Struct-Text">
          <h1 className="Struct-Head">Designing</h1>
          <p className="Struct-Para">
            Our civil engineering design services blend creativity with
            technical expertise to create functional, sustainable, and
            aesthetically pleasing infrastructures. We ensure that every design
            meets the project's goals while adhering to safety and regulatory
            standards.
          </p>
          <Button
            href="/Contact"
            className="Struct-Button"
            variant="outline-primary"
          >
            Contact Us
          </Button>
        </Col>
      </Row>

      <Row className="justify-content-center align-items-center mb-5">
        <Col md={6} className="Struct-Text">
          <h1 className="Struct-Head">Estimating</h1>
          <p className="Struct-Para">
            Accurate estimating is crucial for budgeting and resource
            management. We provide precise cost estimates based on a
            comprehensive analysis of materials, labor, and other factors,
            ensuring projects stay within budget without compromising quality or
            safety.
          </p>
          <Button
            href="/Contact"
            className="Struct-Button"
            variant="outline-danger"
          >
            Contact Us
          </Button>
        </Col>
        <Col md={6}>
          <img
            src="/assets/images/c3.jpg"
            alt="Structural"
            style={{
              borderRadius: "25px",
              boxShadow: "8px 8px 5px rgba(0, 0, 0, 0.1)",
            }}
          />
        </Col>
      </Row>
      <hr style={hrStyles} />
    </Container>
  );
}
